import React from "react";
import image from "../layout/img/imsoft.svg";

function Asosi() {
  return (
    <div className="glavni-img">
      <img src={image} alt="imsoft group" />
    </div>
  );
}

export default Asosi;
